import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { generateCustomizedSyncBody } from 'utils/CustomizedSync'
import { combineEpicsIsolated } from 'utils/epicRegistry'
import { INTEGRATION_TYPE } from 'utils/integrations'

import { addToast } from 'containers/Toasts/actions'

import {
  fetchDataError,
  fetchDataSuccess,
  submitCustomizedSyncError,
  submitCustomizedSyncSuccess,
} from './actions'
import {
  DATA_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC,
} from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DATA_REQUEST_ASYNC.INITIATE, SEARCH_CHANGE, PAGINATE_CHANGE),
    mergeMap(() =>
      api.mailboxes
        .getCustomizedAutoSyncData(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.customizedautosync.self.integrationType,
          state$.value.customizedautosync.self.search,
          state$.value.customizedautosync.self.integrationType === INTEGRATION_TYPE.GSUITE &&
            state$.value.mailboxes.upload.gdAdminEmail,
          state$.value.customizedautosync.self.page || 1
        )
        .pipe(
          map((response) => fetchDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error)))
        )
    )
  )

const submitCustomizedSyncEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.INITIATE),
    mergeMap(() =>
      api.mailboxes
        .updateCustomizedAutoSyncData(
          state$.value.partnerOptions.selectedCompany?.value,
          generateCustomizedSyncBody(state$)
        )
        .pipe(
          map((response) => submitCustomizedSyncSuccess(response)),
          catchError((error) =>
            of(
              epicsErrorHandler(submitCustomizedSyncError, error),
              addToast({ message: error.response?.message, type: 'error' })
            )
          )
        )
    )
  )

export default combineEpicsIsolated(fetchDataEpic, submitCustomizedSyncEpic)
